
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import { UserResponse, User } from '../../webservices/models';

@Component({
    name: 'UsersTable',
})
export default class UsersTable extends Vue {
    private mainStore = mainStore.context(this.$store);

    private genders: string[] = ['female', 'male'];
    private gender: string = '';

    private nationalities: string[] = [
        'AU',
        'BR',
        'CA',
        'CH',
        'DE',
        'DK',
        'ES',
        'FI',
        'FR',
        'GB',
        'IE',
        'IR',
        'NO',
        'NL',
        'NZ',
        'TR',
        'US',
    ];
    private nationality: string = '';
    private age: number = 0;

    private get users(): UserResponse | null {
        return this.mainStore.state.users;
    }
    private get isLoading(): boolean {
        return this.mainStore.state.isLoading;
    }
    private get favUsers(): User[] {
        return this.mainStore.state.favUsers;
    }
    private get usersToDownload(): object[] {
        return this.mainStore.getters.usersToDownload;
    }

    private getUsers(): void {
        this.mainStore.actions.getUsers();
    }
    private openUser(user: User): void {
        this.mainStore.actions.changeCurrentUser(user);
        this.$router.push({ name: 'User' });
    }
    private addFavUser(user: User): void {
        this.mainStore.actions.updateFavUsers(user);
    }
    private onChangeGender(): void {
        this.mainStore.actions.changeGender(this.gender);
    }
    private onChangeNationality(): void {
        this.mainStore.actions.changeNationality(this.nationality);
    }
    private onChangeAge(): void {
        this.mainStore.actions.changeAge(this.age);
    }
}
